<template>
  <esg-base-chart height="300px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart ref="chart"
                v-show="!loading"
                type="bar"
                :width=this.width
                :height=this.height
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>

<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    corporation: {
      type: Object,
      default() {
        return {}
      }
    },
    businessLocation: {
      type: Object,
      default() {
        return {}
      }
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '300px',
    },
    sort: {
      type: String,
      default: 'asc'
    },
  },
  watch: {
    corporation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    },
    businessLocation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    this.abortAjax();
  },
  data() {
    return {
      loading: false,
      fuels: [],
      ascCategories: [],
      descCategories: [],
      ascSeries: [],
      descSeries: [],
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '50%',
            fontFamily: 'NanumGothic',
          }
        },
        tooltip: {
          y: {
            formatter: val => this.formatNumber(val, 0) + '원/tCO2'
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          title: {
            text: '톤당 감축비용 (원/tCO2)',
            style: {
              fontSize: '12px',
              fontWeight: 'normal',
            },
          },
          categories: [],
          labels: {
            formatter: val => this.compactFormatNumber(val)
          },
        },
      }
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let args = {
          groupKeys: [
            'abatement_method_type',
            'abatement_method_type_name'
          ]
        };
        this.corporation.name && (args.corporations = [this.corporation.code])
        this.businessLocation.name && (args.businessLocations = [this.businessLocation.business_location_code])

        let data = new FormData()
        data.append('path', 'esg/cost/main');
        data.append('json', JSON.stringify([args]));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }

        let list = JSON.parse(response.data.data)[0].data;

        this.series = [{ name: '감축비용', data: list.map(row => this.unitAbatementCost(row)) }];
        this.chartOptions.xaxis.categories = list.map(row => row.abatement_method_type_name);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    unitAbatementCost(row) {
      if (row.reduction_total === 0) return null;
      return row.cost_total / row.reduction_total;
    }
  }
}
</script>
<style>
</style>